import { render, staticRenderFns } from "./InvitationSelection.vue?vue&type=template&id=7f0b3976&"
import script from "./InvitationSelection.vue?vue&type=script&lang=js&"
export * from "./InvitationSelection.vue?vue&type=script&lang=js&"
import style0 from "./InvitationSelection.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {InvitationSelectionButton: require('/workspace/components/Invitation/InvitationSelectionButton.vue').default})
